<template>
  <div id="excel-catalogo-conceptos">
    <custom-button
      v-if="boton"
      label="Exportar"
      iconText="fa-file-excel"
      tipo="agregar"
      class="mr-2"
      :loading="estaCargando"
      @click="generarExcelCatalogo"
    >
    </custom-button>
    <v-list-item
      v-else
      @click="generarExcelCatalogo"
      link>
      <v-list-item-icon>
        <v-icon
        color="secondary"> fa-file-excel </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> EXPORTAR </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 14;
const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 2;

export default {
  name: 'ExcelCatalogo',
  mixins: [mixGenerarExceles],
  props: {
    catalogoConceptos: {
      type: Array,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    boton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      estaCargando: false,
      nombreDocumento: 'CATALOGO',
      configuracionExcel: {},
      filaTitulos: 2,
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        },
      },
      logoDocumento: [
        {
          // este path de la imagen del logo corresponde a la ruta en el servidor de la API
          path: 'public/img/logos/daesa-logo.png',
          type: 'picture',
          position: {
            type: 'twoCellAnchor',
            from: {
              col: 1,
              colOff: 0,
              row: 2,
              rowOff: 0,
            },
            to: {
              col: 3,
              colOff: 0,
              row: 4,
              rowOff: 0,
            },
          },
        },
      ],
      // Datos de los encabezados que apareceran en el excel.
      headers: [
        {
          value: 'Clave', combinar: { row: filaSubtitulos, col: 1 },
        },
        {
          value: 'Concepto', combinar: { row: filaSubtitulos, col: 2 },
        },
        {
          value: 'Unidad', combinar: { row: filaSubtitulos, col: 3 },
        },
        {
          value: 'Cantidad', combinar: { row: filaSubtitulos, col: 4 },
        },
        {
          value: 'Precio Unitario',
          combinar: { row: filaSubtitulos, col: 5 },
          estilo: {
            font: {
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
              wrapText: true,
            },
          },
        },
        {
          value: 'Importe', combinar: { row: filaSubtitulos, col: 6 },
        },
      ],
      // Datos de las columnas que aparecerán en el excel.
      columnas: [
        'clave',
        'concepto',
        'unidad',
        'cantidad',
        'precioUnitario',
        'importe',
      ],
    };
  },
  methods: {
    async generarExcelCatalogo() {
      const data = this.crearExcelFiniquito;
      await this.mixGenerarExcel(data);
    },
  },
  computed: {
    crearCatalogoParaExcel() {
      const catalogo = this.catalogoConceptos;
      return catalogo.sort((a, b) => a.orden - b.orden);
    },

    crearDatosDocumento() {
      return [
        {
          value: 'DAESA INGENIERIA',
          row: 2,
          col: 5,
          estilo: {
            font: {
              size: 18,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 2,
            col: 13,
          },
        },
        {
          value: 'CATALOGO DE CONCEPTOS',
          row: 3,
          col: 5,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 3,
            col: 13,
          },
        },
        {
          value: 'Contrato:',
          row: 7,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
          },
        },
        {
          value: this.contrato.numero,
          row: 7,
          col: 2,
          estilo: {
            font: {
              size: 14,
              bold: false,
            },
            alignment: {
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 7,
            col: 15,
          },
        },
        {
          value: 'Objeto:',
          row: 8,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
          },
        },
        {
          value: this.contrato.meta,
          row: 8,
          col: 2,
          estilo: {
            font: {
              size: 14,
              bold: false,
            },
            alignment: {
              vertical: 'center',
              wrapText: true,
            },
          },
          combinar: {
            row: 11,
            col: 15,
          },
        },
        {
          value: 'Contratista:',
          row: 12,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
          },
        },
        {
          value: this.contrato.contratista.nombreRazonSocial,
          row: 12,
          col: 2,
          estilo: {
            font: {
              size: 14,
              bold: false,
            },
          },
          combinar: {
            row: 12,
            col: 15,
          },
        },
      ];
    },

    crearExcelFiniquito() {
      const catalogoConceptosExcel = this.crearCatalogoParaExcel;
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.headers;
      const nombreDeColumnas = [...this.columnas];

      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: [...catalogoConceptosExcel],
          },
        },
      };
      return data;
    },
  },

};
</script>

<style>

</style>
